import classes from "./LittleNotify.module.css";

import "animate.css";

type Props = {
  close: () => void;
  title: string;
  descr?: string;
  error?: boolean;
};

const LittleNotify = ({ close, title, descr, error }: Props) => {
  const closeBtn = process.env.PUBLIC_URL + '/images/canсel_white.png'
  return (
    <div
      className={`${
        classes.notify__wrapper
      } animate__animated animate__backInRight ${
        error ? classes.notify__error : ""
      }`}
    >
      <div onClick={close} className={classes.notify__close}>
        <img src={closeBtn} alt="Закрыть" />
      </div>
      <div className={classes.notify__title}>{title}</div>

      {descr && <div className={classes.notify__descr}>{descr}</div>}
    </div>
  );
};

export default LittleNotify;
